export default {
  suppliers: '/',
  details: '/detalle/:id',
};
